<template>
  <svg :width="width" :height="height" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_16571_26384)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.1392 7.30786C16.0561 11.0294 14.1155 14.1177 11.4784 14.1177C8.78261 14.1177 6.81369 10.8902 6.81369 7.05884C6.81369 3.22746 8.78257 0 11.4784 0C14.1155 0 16.056 3.08837 16.1392 6.80984L16.142 7.05884L16.1392 7.30786ZM14.273 6.8098C14.1978 4.00679 12.8628 1.88236 11.4784 1.88236C10.0529 1.88236 8.67934 4.13394 8.67934 7.05884C8.67934 9.98371 10.0529 12.2353 11.4784 12.2353C12.8628 12.2353 14.1978 10.111 14.273 7.3079L14.2763 7.05884L14.273 6.8098Z"
        :fill="color"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.19712 22.5883C6.54132 22.5883 8.30536 20.1307 8.39209 17.1699L8.39544 16.9412L8.39209 16.7125C8.30535 13.7519 6.54129 11.2942 4.19712 11.2942C1.79296 11.2942 0 13.8793 0 16.9412C0 20.0032 1.79294 22.5883 4.19712 22.5883ZM4.19712 13.1765C5.35955 13.1765 6.45436 14.6984 6.52606 16.7294L6.52978 16.9412L6.52606 17.1531C6.45436 19.1842 5.35959 20.7059 4.19712 20.7059C2.99497 20.7059 1.86565 19.0777 1.86565 16.9412C1.86565 14.8048 2.99499 13.1765 4.19712 13.1765Z"
        :fill="color"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.0002 30.3732C3.30421 26.3694 10.3956 14.2994 15.6924 14.2994C21.0288 14.2994 28.1163 26.2941 24.3509 30.3719C23.1886 31.631 21.819 32.102 20.2102 31.9802C19.5188 31.9279 18.9292 31.8005 17.8729 31.5152L17.4325 31.3976C16.6249 31.1854 16.234 31.1073 15.8464 31.0965L15.4826 31.0963C15.1452 31.1054 14.7867 31.1735 14.0799 31.3563L12.9873 31.6458C12.2233 31.8418 11.7177 31.9377 11.1413 31.9814C9.53236 32.1034 8.16254 31.6324 7.0002 30.3732ZM22.9858 29.0888C25.53 26.3335 19.5315 16.1818 15.6924 16.1818C11.8952 16.1818 5.88795 26.4065 8.36545 29.0903C9.11895 29.9066 9.93028 30.1855 11.0015 30.1043C11.4521 30.0701 11.8785 29.9885 12.557 29.8139L13.2474 29.6301C14.3726 29.3292 14.8739 29.2227 15.4144 29.2132L15.6505 29.2147C16.257 29.1983 16.6959 29.265 17.658 29.5121L18.7948 29.813C19.4731 29.9875 19.8993 30.069 20.3498 30.1031C21.4209 30.1842 22.2322 29.9052 22.9858 29.0888Z"
        :fill="color"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.8029 23.5295C30.1471 23.5295 31.91 21.0722 31.9967 18.1105L32 17.8817L31.9967 17.653C31.91 14.6925 30.1469 12.2353 27.8029 12.2353C25.3986 12.2353 23.6046 14.8203 23.6046 17.8817C23.6046 20.9442 25.3984 23.5295 27.8029 23.5295ZM27.8029 14.1177C28.965 14.1177 30.059 15.6389 30.1306 17.6698L30.1343 17.8817L30.1306 18.0937C30.059 20.1258 28.9651 21.6471 27.8029 21.6471C26.6002 21.6471 25.4702 20.0186 25.4702 17.8817C25.4702 15.7459 26.6003 14.1177 27.8029 14.1177Z"
        :fill="color"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.4003 7.30784C26.3171 11.0291 24.3756 14.1177 21.7383 14.1177C19.0426 14.1177 17.0748 10.8905 17.0748 7.05884C17.0748 3.22714 19.0426 0 21.7383 0C24.3755 0 26.3171 3.08869 26.4003 6.80986L26.403 7.05884L26.4003 7.30784ZM24.5341 6.80983C24.4589 4.00715 23.1231 1.88236 21.7383 1.88236C20.3132 1.88236 18.9404 4.13357 18.9404 7.05884C18.9404 9.9841 20.3132 12.2353 21.7383 12.2353C23.1231 12.2353 24.4589 10.1106 24.5341 7.30787L24.5374 7.05884L24.5341 6.80983Z"
        :fill="color"
      />
    </g>
  </svg>
</template>

<script lang="ts">
export default {
  name: 'PetsIcon',
  props: {
    width: {
      type: Number,
      default: 32,
    },
    height: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: '#4B4C52',
    },
  },
};
</script>
